import { XIcon } from "@heroicons/react/outline";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { toast } from "react-toastify";
import {
  addQuestion,
  getPayload,
  getQuestion,
  saveQuestion,
  updateQuestion,
  postQuestionTag,
  deleteQuestionTag,
  getQuestionPayloadByItemReference,
} from "../../../api/question.service";
import { getAssociatedStandards } from "../../../api/standardLinking.service";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import {
  IAssociatedPassages,
  IAssociatedVideos,
  IQuestion,
} from "../../../model/interface/question";
import constant from "../../../utils/constant";
import { hasDisallowedImageSourcesInRequest } from "../../../utils/imageSourceHelper";
import Breadcrumb from "../../shared/common/breadcrumb";
import DelinkStandardPopup from "../../shared/common/delinkStandardPopup";
import Loader from "../../shared/loader/loader";
import ImageGallery from "../questions/imageGallery/imageGallery";
import AuthorQuestionLanguageTabs from "./authorQuestionLanguageTabs";
import AuthorQuestionTabs from "./authorQuestionTabs";
import { IlinkedStandard } from "../../../model/interface/linkedStandard";
import PreviewModal from "./previewModal";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";

const getParameters = (location: any) => {
  if (location.pathname.toUpperCase().includes(constant.PageMode.EDIT)) {
    return null;
  }

  let state =
    location?.state?.associateStandardId != null ? location.state : null;
  if (state) return state;

  state = localStorage.getItem(constant.FROM_ASSOCIATE_STANDARD_KEY);
  if (state) {
    return JSON.parse(state);
  }
};

const AuthorQuestion: React.FC = (props: any) => {
  const COPYQUESTIONKEY = "COPYQUESTIONKEY";
  const COPYQUESTIONWIDGETSEN = "COPYQUESTIONWIDGETSEN";
  const COPYQUESTIONWIDGETSES = "COPYQUESTIONWIDGETSES";
  const [selectedV, setSelectedV] = useState<string>("");
  const [app, setAuthorApp] = useState<any>();
  const [appES, setAuthorAppES] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [payload, setPayload] = useState<any>();
  const [payloadLabel, setpayloadLabel] = useState<string>();
  const [questionId, setQuestionId] = useState<string>("");
  const [language, setLanguageTab] = useState<string>("EN");
  const [widgetDataEN, setWidgetEN] = useState<any>();
  const [widgetDataES, setWidgetES] = useState<any>();
  const [isSubTypeChanged, setSubTypeChanged] = useState<boolean>(false);
  const [questionEditor, setQuestionEditor] = useState<any>();
  const [selectedStateId, setStateId] = useState<number>(0);
  const [selectedSubjectId, setSubjectId] = useState<number>(0);
  const [selectedDomainId, SetDomainId] = useState<string>("");
  const [selectedStandardId, SetStandardId] = useState<number>(0);
  const [selectedSubType, setSelectedSubType] = useState<string>("");
  const [selectedDOKId, SetDOKId] = useState<number>(0);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isPublished, setIsPublished] = useState<boolean>(false);
  const [isDiagnostics, setIsDiagnostics] = useState<boolean>(false);
  const [isAIAssisted, setIsAIAssisted] = useState<boolean>(false);
  const [classification, setClassification] = useState<number | undefined>(
    undefined
  );
  const [externalSourceTypeId, setExternalSourceTypeId] = useState<
    number | undefined
  >();
  const [externalSourceId, setExternalSourceId] = useState<string>("");
  const [questionTypeId, setQuestionTypeId] = useState<number>(0);
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const [settingsDataEN, setSettingsDataEN] = useState<any>({
    videoExplanation: "",
    textExplanation: "",
    disableQuestionTTS: false,
    disableAnswerTTS: false,
    questionTTS: "",
    answerTTS: "",
    notes: "",
    settings: [],
  });
  const [settingsDataES, setSettingsDataES] = useState<any>({
    videoExplanation: "",
    textExplanation: "",
    disableQuestionTTS: false,
    disableAnswerTTS: false,
    questionTTS: "",
    answerTTS: "",
    notes: "",
  });
  const [showImageGalleryPopup, setShowImageGalleryPopup] = useState(false);
  const [questionEditData, setQuestionEditData] = useState<IQuestion>({});
  const [copyQuestionData, setCopyQuestionData] = useState<IQuestion>({});
  const [editFlag, setEditFlag] = useState<boolean>(false);
  const [copyFlag, setCopyFlag] = useState<boolean>(false);
  const [englishRefId, setEnglishRefId] = useState("");
  const [spanishRefId, setSpanishRefId] = useState("");
  const [associateQuestionTag, setAssociateQuestionTag] = useState<any>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const state = getParameters(location);
  const questionIdToEdit = useNumericParam("id");
  const [parameters, setParameters] = useState<any>(state);
  const [selectedTags, setSelectedTags] = useState<ISelectElement>();
  const [esTranslationDone, setESTranslationDone] = useState<boolean>(false);
  const [showLinkedStandards, setShowLinkedStandards] =
    useState<boolean>(false);
  const [linkedStandards, setLinkedStandards] = useState<IlinkedStandard[]>([]);
  const [passageClassification, setPassageClassification] = useState<
    string | undefined
  >(state?.passageClassification);
  const [addQuestionIndex, setAddQuestionIndex] = useState<number>(0);
  const [addSpanishQuestionIndex, setAddSpanishQuestionIndex] =
    useState<number>(0);
  const [englishWidgetDataArray, setEnglishWidgetDataArray] = useState<any[]>(
    []
  );
  const [spanishWidgetDataArray, setSpanishWidgetDataArray] = useState<any[]>(
    []
  );
  const [questionAssociatedPassageIds, SetQuestionAssociatedPassageIds] =
    useState<IAssociatedPassages | undefined>(
      state?.associatedPassageId
        ? [
            {
              associatedPassageId: state?.associatedPassageId,
              associatedPassageReferenceIds: [
                state?.associatedEnglishPsgRefId,
                state?.associatedSpanishPsgRefId,
              ],
            },
          ]
        : undefined
    );
  const [questionAssociatedPassage, SetQuestionAssociatedPassage] = useState<
    ISelectElement[] | undefined
  >(
    state?.associatedPassageId
      ? [
          {
            label: state?.associatedPassageTitle,
            value: state?.associatedPassageId,
          },
        ]
      : undefined
  );
  const [questionAssociatedVideoIds, SetQuestionAssociatedVideoIds] = useState<
    IAssociatedVideos | undefined
  >(
    state?.associateVideoId
      ? [
          {
            associatedVideoId: state?.associateVideoId,
            associatedVideoReferenceIds: [
              state?.associatedEnglishVideoRefId,
              state?.associatedSpanishVideoRefId,
            ],
          },
        ]
      : undefined
  );
  const [open, setOpen] = useState<boolean>(false);
  const [previewId, setPreviewId] = useState<string>("");
  const [questionIdPreview, setQuestionIdPreview] = useState<number>();

  const [questionToPreview, setQuestionToPreview] = useState<
    IQuestion | undefined
  >();
  const [questionIdCopiedFrom, setQuestionIdCopiedFrom] = useState<number>(0);
  enum Language {
    English = 1,
    Spanish = 2,
  }

  const [arr, setArray] = useState<number[]>([]);
  const AddDivElement = (e) => {
    const index = addQuestionIndex + 1;
    arr.push(index);
    setArray([...arr]);
    setAddQuestionIndex(index);
  };
  const [standardToDelink, setStandardToDelink] = useState<number>(0);
  const [unlinkedStandardId, setUnlinkedStandardId] = useState<number>(0);
  const [showSetAnswerErrorEnglish, setShowSetAnswerErrorEnglish] =
    useState<boolean>(false);
  const [showSetAnswerErrorSpanish, setShowSetAnswerErrorSpanish] =
    useState<boolean>(false);
  const [changeTab, setChangeTab] = useState<boolean>(false);
  const [isMachineTranslated, setIsMachineTranslated] =
    useState<boolean>(false);
  const [autoMaskResponseEn, setAutoMaskResponseEn] = useState<string[]>([]);

  useEffect(() => {
    if (questionIdToEdit === 0) {
      navigate(constant.BAD_REQUEST);
    } else if (questionIdToEdit) {
      fetchQuestionDetails(questionIdToEdit);
    }
  }, [questionIdToEdit]);

  useEffect(() => {
    const questionId = localStorage.getItem(COPYQUESTIONKEY);
    if (questionId && parseInt(questionId) > 0) {
      setCopyFlag(true);
      setQuestionIdCopiedFrom(parseInt(questionId));
      fetchCopyQuestionDetails(Number(questionId));
    }
    localStorage.removeItem(COPYQUESTIONKEY);
    localStorage.removeItem(constant.FROM_ASSOCIATE_STANDARD_KEY);
  }, []);

  async function checkLinkedStandards(standardId: number) {
    setLoading(true);

    await getAssociatedStandards(standardId).then((response) => {
      setLoading(false);
      if (response && response.data.length > 0) {
        setStandardToDelink(standardId);
        setShowLinkedStandards(true);
        setLinkedStandards(response.data);
      } else {
        refreshQuestion();
      }
    });
  }

  const refreshQuestion = () => {
    if (!editFlag) {
      navigate(constant.MANAGEQUESTION.replace(":id", questionId));
    } else if (questionIdToEdit) {
      fetchQuestionDetails(questionIdToEdit);
    }
  };

  const closeLinkedStandardsPopUp = () => {
    setShowLinkedStandards(false);
    refreshQuestion();
  };

  function fetchQuestionDetails(questionIdToEdit: number) {
    setLoading(true);
    getQuestion(questionIdToEdit).then((response: any) => {
      setQuestionEditData(response.data);
      setQuestionId(String(questionIdToEdit));
      setEditFlag(true);
      setLoading(false);
    });
  }

  function fetchCopyQuestionDetails(questionId: number) {
    setLoading(true);
    getQuestion(questionId).then((response: any) => {
      setCopyQuestionData(response.data);
      bindCopyQuestion(response.data);
      setCopyFlag(true);
      getAssociatePassagesForCopyQuestion(questionId);
      getAssociateVideosForCopyQuestion(questionId);
      setLoading(false);
    });
  }

  useEffect(() => {
    if (editFlag) {
      setStateId(questionEditData.stateId ? questionEditData.stateId : 0);
      setSubjectId(questionEditData.subjectId ? questionEditData.subjectId : 0);
      SetDomainId(
        questionEditData.domainId ? String(questionEditData.domainId) : ""
      );
      SetStandardId(
        questionEditData.standardId ? questionEditData.standardId : 0
      );
      SetDOKId(questionEditData.dok ? questionEditData.dok : 0);
      setIsActive(
        questionEditData.isActive ? questionEditData.isActive : false
      );
      setIsPublished(
        questionEditData.isPublished ? questionEditData.isPublished : false
      );
      setIsAIAssisted(
        questionEditData.isAIAssisted ? questionEditData.isAIAssisted : false
      );
      setIsMachineTranslated(
        questionEditData.isMachineTranslated
          ? questionEditData.isMachineTranslated
          : false
      );
      if (questionEditData.questionClassificationId) {
        setClassification(questionEditData.questionClassificationId);
      } else {
        setClassification(undefined);
      }
      setIsDiagnostics(
        questionEditData.isDiagnostics ? questionEditData.isDiagnostics : false
      );
      if (questionEditData.externalSource) {
        setExternalSourceTypeId(
          questionEditData.externalSource.externalSourceTypeId
        );
        setExternalSourceId(questionEditData.externalSource.externalSourceId);
      }
      setQuestionTypeId(
        questionEditData.questionTypeId ? questionEditData.questionTypeId : 0
      );
      setEnglishRefId(
        questionEditData.englishQuestionReferenceId
          ? questionEditData.englishQuestionReferenceId
          : ""
      );
      setSpanishRefId(
        questionEditData.spanishQuestionReferenceId
          ? questionEditData.spanishQuestionReferenceId
          : ""
      );

      const settingEN = questionEditData.settings?.find(
        (languageId) => languageId.languageId === Language.English
      );
      const settingES = questionEditData.settings?.find(
        (languageId) => languageId.languageId === Language.Spanish
      );
      setSettingsDataEN(settingEN);
      setSettingsDataES(settingES);
      setESTranslationDone(questionEditData?.isHumanTranslated || false);
      if (questionEditData?.tags?.length) {
        const tags: any = questionEditData.tags.map((ds) => {
          return { label: ds.name, value: ds.tagId };
        });
        setSelectedTags(tags);
      }
      getAssociatePassages();
      bindTags();
      getAssociateVideos();
    }
  }, [questionEditData, editFlag]);

  useEffect(() => {
    if (questionTypeId > 0 && payload && copyQuestionData && copyFlag) {
      createCopyQuestion(copyQuestionData);
    }
  }, [payload, questionTypeId, copyQuestionData]);

  useEffect(() => {
    if (copyQuestionData && questionId && copyFlag) {
      const itemReferences: string[] = [];
      itemReferences.push(copyQuestionData?.englishQuestionReferenceId ?? "");
      itemReferences.push(copyQuestionData?.spanishQuestionReferenceId ?? "");
      getQuestionPayloadByItemReference(itemReferences).then((res) => {
        if (res.data) {
          const questionENString = res.data.filter(
            (x) => x.key === copyQuestionData.englishQuestionReferenceId
          )[0]?.value;
          const QuestionArrayEN = questionENString
            ? JSON.parse(questionENString)
            : null;
          setEnglishWidgetDataArray(QuestionArrayEN);

          const timeGap = 500;
          for (let i = 0; i < QuestionArrayEN?.length - 1; i++) {
            const timeout = (i * 2 + 2) * 1000 + timeGap;
            setTimeout(function () {
              const index = i + 1;
              arr.push(index);
              setArray([...arr]);
              setAddQuestionIndex(index);
            }, timeout);
          }
        }
      });
    }
  }, [copyFlag, copyQuestionData, questionId]);

  const saveSelectdData1 = (e) => {
    setSelectedV(e);
  };

  const bindTags = () => {
    const tags = questionEditData.tags?.map((item) => item.tagId);
    if (tags && tags.length > 0) {
      setSelectedTagIds(tags);
    }
  };

  const authorAppParent = (app) => {
    setAuthorApp(app);
    if (app.getItem().questions.length > 0 && arr.length == 0 && editFlag) {
      for (let i = 0; i < app.getItem().questions.length - 1; i++) {
        const timeout = (i * 2 + 2) * 1000;
        setTimeout(function () {
          const index = i + 1;
          arr.push(index);
          setArray([...arr]);
          setAddQuestionIndex(index);
        }, timeout);
      }
    }
  };

  const authorAppParentES = (appES) => {
    setAuthorAppES(appES);
  };

  const getQuestionTypePayloadSchema = (subType) => {
    setLoading(true);
    getPayload(subType).then((res) => {
      const questionData = res.data;
      setPayload(res.data);
      setLoading(false);
    });
  };

  const setWidget = (subType, label) => {
    if (selectedSubType !== subType) {
      setLoading(true);
      setSubTypeChanged(true);
      setSelectedSubType(subType);
      if (questionId !== undefined && questionId !== "") {
        if (appES !== undefined) {
          setSubTypeChanged(true);
        }
        getPayload(subType).then((res) => {
          const questionData = res.data;
          setPayload(res.data);
          setLoading(false);
          if (questionData !== undefined) {
            if (language === "EN" && app !== undefined) {
              if (arr.length > 0) {
                setQuestionEditor("");
                for (let i = 0; i <= arr.length; i++) {
                  const timeout = (i * 2 + 2) * 1000;
                  setTimeout(function () {
                    setAddQuestionIndex(i);
                  }, timeout);
                }
              } else {
                app.setWidget(questionData, label);
                setWidgetEN(app.getWidget());
              }
            } else if (appES !== undefined) {
              appES.setWidget(questionData, label);
              setWidgetES(appES.getWidget());
            }
          }
        });
      }
    }
  };

  const createQuestion = (type, id) => {
    const question: IQuestion = {
      createdByUserId: props.profile?.userId || 1,
      stateId: type === "state" ? id : Number(selectedStateId),
      subjectId: selectedSubjectId,
      domainId: type === "domain" ? id : Number(selectedDomainId),
      standardId: parameters?.associateStandardId
        ? parameters?.associateStandardId
        : id,
      dok: selectedDOKId,
      isActive: false,
      isPublished: false,
      isDiagnostics: false,
      questionTypeId: questionTypeId,
      questionClassificationId: classification,
    };
    addQuestion(question).then((response: any) => {
      setQuestionId(response.data);
    });
  };

  const createCopyQuestion = (questionData: IQuestion) => {
    const question: IQuestion = {
      createdByUserId: props.profile?.userId || 1,
      stateId: questionData.stateId,
      subjectId: questionData.subjectId,
      domainId: questionData.domainId,
      standardId: questionData.standardId,
      dok: questionData.dok,
      isActive: questionData.isActive,
      isPublished: questionData.isPublished,
      isDiagnostics: questionData.isDiagnostics,
      questionTypeId: questionData.questionTypeId,
      questionClassificationId: questionData.questionClassificationId,
    };
    addQuestion(question).then((response: any) => {
      setQuestionId(response.data);
    });
  };

  const setUpEditor = () => {
    setQuestionEditor(
      <AuthorQuestionLanguageTabs
        subtype={selectedV}
        authorAppParent={authorAppParent}
        itemRefEN={englishRefId}
        itemRefES={spanishRefId}
        payload={payload}
        authorAppParentES={authorAppParentES}
        setLanguage={setLanguageTab}
        widgetDataEN={widgetDataEN}
        widgetDataES={widgetDataES}
        setWidgetEN={setWidgetEN}
        setWidgetES={setWidgetES}
        isSubTypeChanged={isSubTypeChanged}
        payloadLabel={payloadLabel}
        setSettingsDataEN={setSettingsDataEN}
        setSettingsDataES={setSettingsDataES}
        showImageGalleryPopup={setShowImageGalleryPopup}
        settingsDataEN={settingsDataEN}
        settingsDataES={settingsDataES}
        language={language}
        setSelectedSubType={setSelectedSubType}
        selectedSubType={selectedSubType}
        setSubTypeChanged={setSubTypeChanged}
        setESTranslationDone={esTranslationToggle}
        esTranslationDone={esTranslationDone}
        addQuestionIndex={addQuestionIndex}
        arr={arr}
        englishWidgetDataArray={englishWidgetDataArray}
        setEnglishWidgetDataArray={setEnglishWidgetDataArray}
        addSpanishQuestionIndex={addSpanishQuestionIndex}
        setAddSpanishQuestionIndex={setAddSpanishQuestionIndex}
        spanishWidgetDataArray={spanishWidgetDataArray}
        setSpanishWidgetDataArray={setSpanishWidgetDataArray}
        setAddQuestionIndex={setAddQuestionIndex}
        setLoading={setLoading}
        showSetAnswerErrorEnglish={showSetAnswerErrorEnglish}
        showSetAnswerErrorSpanish={showSetAnswerErrorSpanish}
        changeTab={changeTab}
        setChangeTab={setChangeTab}
        questionTypeId={questionTypeId}
      />
    );
  };

  useEffect(() => {
    if (parameters?.associateStandardId && !copyFlag) {
      SetStandardId(parameters?.associateStandardId);
      if (
        parameters?.associateStandardId &&
        parameters?.associateStandardData
      ) {
        setSubjectId(parameters.associateStandardData.subjectId);
        SetDomainId(parameters.associateStandardData.domainId);
      }
    }
  }, [parameters?.associateStandardId]);

  useEffect(() => {
    if (questionId && !editFlag && copyFlag) {
      setEnglishRefId(questionId + "-en");
      setSpanishRefId(questionId + "-es");
    }
    if (
      questionId !== undefined &&
      questionId !== "" &&
      englishRefId &&
      spanishRefId &&
      copyFlag &&
      englishWidgetDataArray.length > 0
    ) {
      setUpEditor();
    } else if (copyFlag) {
      setQuestionEditor("");
    }
  }, [
    questionId,
    widgetDataEN,
    widgetDataES,
    englishRefId,
    spanishRefId,
    settingsDataEN,
    settingsDataES,
    esTranslationDone,
    addQuestionIndex,
    arr,
    addSpanishQuestionIndex,
    payload,
    showSetAnswerErrorEnglish,
    showSetAnswerErrorSpanish,
    englishWidgetDataArray,
    spanishWidgetDataArray,
    copyFlag,
  ]);

  useEffect(() => {
    if (!copyFlag) {
      if (questionId && !editFlag) {
        setEnglishRefId(questionId + "-en");
        setSpanishRefId(questionId + "-es");
      }
      if (
        questionId !== undefined &&
        questionId !== "" &&
        englishRefId &&
        spanishRefId &&
        payload &&
        !copyFlag
      ) {
        setUpEditor();
      } else if (!copyFlag) {
        setQuestionEditor("");
      }
    }
  }, [
    questionId,
    widgetDataEN,
    widgetDataES,
    englishRefId,
    spanishRefId,
    settingsDataEN,
    settingsDataES,
    esTranslationDone,
    addQuestionIndex,
    arr,
    addSpanishQuestionIndex,
    payload,
    showSetAnswerErrorEnglish,
    showSetAnswerErrorSpanish,
  ]);

  useEffect(() => {
    if (questionTypeId > 0 && !editFlag) {
      if (
        parameters?.associateStandardId &&
        parameters?.associateStandardData &&
        !copyFlag
      ) {
        createQuestion("state", 0);
      }
    }
  }, [questionTypeId]);

  const saveQuestionData = (e, saveAndCopyFlag) => {
    if (selectedDOKId === 0) {
      toast.error("Please select DOK");
      return;
    }
    setShowSetAnswerErrorEnglish(false);
    setShowSetAnswerErrorSpanish(false);
    setChangeTab(false);
    const learnoReqEN = getlearnosityDataEN();
    const learnoReqES = getlearnosityDataES();
    const tags = [] as any;
    const associatedPassageIds = [] as unknown as IAssociatedPassages;
    const associatedVideoIds = [] as unknown as IAssociatedVideos;
    if (learnoReqEN && learnoReqES) {
      if (
        hasDisallowedImageSourcesInRequest(learnoReqEN.quesReqEN) ||
        hasDisallowedImageSourcesInRequest(learnoReqES.quesReqES)
      ) {
        toast.error(constant.PastedImageErrors.Question);
        return;
      }
      if (associateQuestionTag && associateQuestionTag.length > 0) {
        associateQuestionTag.map((tag) => {
          tags.push({
            tagId: tag.tagId,
            name: tag.name,
            contentAreaId: Number(tag.contentAreaId),
            contentAreaName: tag.contentAreaName,
            categoryId: Number(tag.categoryId),
            categoryName: tag.categoryName,
            description: tag.description,
            isActive: tag.isActive,
            color: tag.color,
            userId: props.profile?.userId || 1,
            questionId: Number(questionId),
          });
        });
      }

      //Determine points possible from request to Learnosity
      const learnosityRequest = JSON.parse(learnoReqEN.quesReqEN);
      let score =
        learnosityRequest.questions[0].data?.validation?.valid_response?.score;
      const maxScore =
        learnosityRequest.questions[0].data?.validation?.max_score;
      const hasAIScoring = learnosityRequest.questions.some(
        (question) =>
          question.data?.validation?.score_with_feedbackaide === true
      );

      // For custom questions, the score is not present on validation object
      if (score === undefined) {
        score = learnosityRequest.questions[0].data?.score;
      }

      const question: IQuestion = {
        questionId: Number(questionId),
        createdByUserId: props.profile?.userId || 1,
        stateId: selectedStateId,
        subjectId: selectedSubjectId,
        domainId: Number(selectedDomainId),
        standardId: parameters?.associateStandardId
          ? parameters?.associateStandardId
          : selectedStandardId,
        dok: selectedDOKId,
        isActive: isActive,
        isPublished: isPublished,
        isAIAssisted: isAIAssisted,
        hasAIScoring,
        questionClassificationId: classification,
        isDiagnostics: isDiagnostics,
        questionTypeId: questionTypeId,
        englishQuestionReferenceId: englishRefId,
        spanishQuestionReferenceId: spanishRefId,
        questionText: learnoReqEN.questionText,
        updatedByUserId: props.profile?.userId || 1,
        pointsPossible: score ?? maxScore, //Constructed response type questions use max_score
        settings: [
          {
            disableAnswerTTS: settingsDataEN.disableAnswerTTS,
            languageId: Language.English,
            disableQuestionTTS: settingsDataEN.disableQuestionTTS,
            questionId: Number(questionId),
            questionTTS: settingsDataEN.questionTTS
              ? settingsDataEN.questionTTS
              : "",
            videoExplanation: settingsDataEN.videoExplanation
              ? settingsDataEN.videoExplanation
              : "",
            videoExplanationVttUrl: settingsDataEN.videoExplanationVttUrl
              ? settingsDataEN.videoExplanationVttUrl
              : "",
            notes: settingsDataEN.notes ? settingsDataEN.notes : "",
          },
          {
            disableAnswerTTS: settingsDataES.disableAnswerTTS,
            languageId: Language.Spanish,
            disableQuestionTTS: settingsDataES.disableQuestionTTS,
            questionId: Number(questionId),
            questionTTS: settingsDataES.questionTTS
              ? settingsDataES.questionTTS
              : "",
            videoExplanation: settingsDataES.videoExplanation
              ? settingsDataES.videoExplanation
              : "",
            videoExplanationVttUrl: settingsDataES.videoExplanationVttUrl
              ? settingsDataES.videoExplanationVttUrl
              : "",
            notes: settingsDataES.notes ? settingsDataES.notes : "",
          },
        ],
        tags: tags,
        learnosityItem: {
          itemRequestEN: learnoReqEN.itemReqEN,
          questionRequestEN: learnoReqEN.quesReqEN,
          itemRequestES: learnoReqES.itemReqES,
          questionRequestES: learnoReqES.quesReqES,
          questionId: Number(questionId),
          spanishReferenceId: spanishRefId,
          englishReferenceId: englishRefId,
          passageReferenceIds: questionAssociatedPassageIds
            ? questionAssociatedPassageIds
            : associatedPassageIds,
          videoReferenceIds: questionAssociatedVideoIds
            ? questionAssociatedVideoIds
            : associatedVideoIds,
          isAutoTranslated: isMachineTranslated,
          isHumanTranslated: esTranslationDone,
          isPublished: isPublished,
        },
        isHumanTranslated: esTranslationDone,
        isMachineTranslated: isMachineTranslated,
        questionIdCopiedFrom:
          questionIdCopiedFrom > 0 ? questionIdCopiedFrom : undefined,
      };

      if (externalSourceTypeId)
        question.externalSource = {
          externalSourceTypeId: externalSourceTypeId,
          externalSourceId: externalSourceId,
        };

      if (editFlag) {
        setLoading(true);
        updateQuestion(question).then(async (response: any) => {
          toast.success("Question updated successfully");
          setLoading(false);
          if (saveAndCopyFlag) {
            handleSaveAndCopy(questionId);
          } else if (
            questionEditData.standardId &&
            questionEditData.standardId !== question.standardId
          ) {
            await checkLinkedStandards(question.standardId || 0);
          } else {
            refreshQuestion();
          }
        });
      } else {
        setLoading(true);
        question.statistics = {
          questionId: Number(questionId),
          answered: 0,
          answeredCorrectly: 0,
          percentCorrect: 0,
          feedbackCount: 0,
          assessmentCount: 0,
        };

        saveQuestion(question).then((response: any) => {
          setLoading(false);
          if (response.data == 1) {
            toast.success("Question saved successfully");
            if (saveAndCopyFlag) {
              handleSaveAndCopy(questionId);
            } else {
              checkLinkedStandards(question?.standardId || 0);
            }
          } else {
            toast.error("Something went wrong");
          }
        });
      }
    } else {
      if (!learnoReqEN) {
        setShowSetAnswerErrorEnglish(true);
        if (language !== "EN") {
          setChangeTab(true);
        }
      } else {
        setShowSetAnswerErrorSpanish(true);
        if (language !== "ES") {
          setChangeTab(true);
        }
      }
    }
  };

  const handleSaveAndCopy = (questionId: string) => {
    localStorage.removeItem(COPYQUESTIONKEY);
    localStorage.setItem(COPYQUESTIONKEY, questionId);
    if (editFlag) {
      navigate(constant.AUTHORQUESTION);
    } else {
      navigate(constant.AUTHORQUESTION, { replace: true });
    }
  };

  const bindCopyQuestion = (question: IQuestion) => {
    setStateId(question.stateId ? question.stateId : 0);
    setSubjectId(question.subjectId ? question.subjectId : 0);
    SetDomainId(question.domainId ? String(question.domainId) : "");
    SetStandardId(question.standardId ? question.standardId : 0);
    SetDOKId(question.dok ? question.dok : 0);
    setIsPublished(false);
    setIsMachineTranslated(false);
    if (question.questionClassificationId) {
      setClassification(question.questionClassificationId);
    } else {
      setClassification(undefined);
    }
    setIsDiagnostics(question.isDiagnostics ? question.isDiagnostics : false);
    setQuestionTypeId(question.questionTypeId ? question.questionTypeId : 0);
    const settingEN = question.settings?.find(
      (languageId) => languageId.languageId === Language.English
    );
    const settingES = question.settings?.find(
      (languageId) => languageId.languageId === Language.Spanish
    );
    setSettingsDataEN(settingEN);
    setSettingsDataES(settingES);
    setESTranslationDone(false);
    if (question?.tags?.length) {
      const tags: any = question.tags.map((ds) => {
        return { label: ds.name, value: ds.tagId };
      });
      setSelectedTags(tags);
      const tagIds = question.tags?.map((item) => item.tagId);
      if (tagIds && tagIds.length > 0) {
        setSelectedTagIds(tagIds);
      }
    }
  };

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Question", url: constant.QUESTION },
      { name: editFlag ? "Edit Question" : "Create Question", url: "" },
    ];

    if (questionIdToEdit) {
      items.push({ name: "", url: "", objectId: questionIdToEdit?.toString() });
    }
    return items;
  };

  const getQuestionTag = (tag) => {
    setAssociateQuestionTag(tag);
  };

  const getlearnosityDataEN = () => {
    const itemData = app?.getItem();
    const questionReq = createQuestionRequestEN();
    if (questionReq) {
      const itemReq = createItemRequestEN(itemData);
      const data = {
        itemReqEN: JSON.stringify(itemReq),
        quesReqEN: JSON.stringify(questionReq),
        questionText:
          (englishWidgetDataArray &&
            englishWidgetDataArray.length > 0 &&
            englishWidgetDataArray[0]["stimulus"]) ||
          "",
      };
      return data;
    } else {
      return false;
    }
  };

  const getlearnosityDataES = () => {
    if (editFlag && (appES === undefined || appES === null)) {
      const data = {
        itemReqES: "",
        quesReqES: "",
      };
      return data;
    } else {
      const itemData =
        appES !== undefined && appES !== null
          ? appES?.getItem()
          : app?.getItem();

      const questionReq = createQuestionRequestES();
      if (questionReq) {
        itemData.item.reference = spanishRefId;
        const itemReq = createItemRequestES(itemData);
        const data = {
          itemReqES: JSON.stringify(itemReq),
          quesReqES: JSON.stringify(questionReq),
        };
        return data;
      } else {
        return false;
      }
    }
  };

  const createQuestionRequestEN = () => {
    const questionArray: any[] = [];
    let setAnswer = true;
    englishWidgetDataArray.forEach((element, index) => {
      const queNo = index + 1;
      if (setAnswer) {
        setAnswer = IsAnswerSet(element);
        if (setAnswer) {
          if (element?.type === "mcq") {
            element = UpdateMetadataForSingleMCQ(element, "en", index);
          }
          questionArray.push({
            type: element?.type,
            reference: !editFlag
              ? questionId + "-q-" + queNo + "-en"
              : app.getItem().questions[index]
              ? app.getItem().questions[index].reference
              : questionId + "-q-" + queNo + "-en",
            data: element,
          });
        }
      } else {
        return false;
      }
    });

    if (setAnswer) {
      const req = {
        questions: questionArray,
      };
      return req;
    } else {
      return false;
    }
  };

  const createItemRequestEN = (item) => {
    const questionRefArray: any[] = [];
    englishWidgetDataArray.forEach((element, index) => {
      const queNo = index + 1;
      questionRefArray.push({
        reference: !editFlag
          ? questionId + "-q-" + queNo + "-en"
          : app.getItem().questions[index]
          ? app.getItem().questions[index].reference
          : questionId + "-q-" + queNo + "-en",
      });
    });
    const req = {
      items: [
        {
          reference: item?.item?.reference,
          metadata: null,
          definition: {
            widgets: questionRefArray,
          },
          status: "published",
          questions: questionRefArray,
          tags: [
            {
              type: "item-type",
              name: "Question",
            },
          ],
        },
      ],
    };
    return req;
  };

  const createQuestionRequestES = () => {
    const questionArray: any[] = [];
    let setAnswer = true;
    if (spanishWidgetDataArray.length == 0) {
      englishWidgetDataArray.forEach((element, index) => {
        if (setAnswer) {
          setAnswer = IsAnswerSet(element);
          const queNo = index + 1;
          if (setAnswer) {
            if (element?.type === "mcq") {
              element = UpdateMetadataForSingleMCQ(element, "es", index);
            }
            questionArray.push({
              type: element.type,
              reference: !editFlag
                ? questionId + "-q-" + queNo + "-es"
                : appES && appES.getItem().questions[index]
                ? appES.getItem().questions[index].reference
                : questionId + "-q-" + queNo + "-es",
              data: element,
            });
          }
        } else {
          return false;
        }
      });
    } else {
      spanishWidgetDataArray.forEach((element, index) => {
        const queNo = index + 1;
        if (setAnswer) {
          setAnswer = IsAnswerSet(element);
          if (setAnswer) {
            if (element?.type === "mcq") {
              element = UpdateMetadataForSingleMCQ(element, "es", index);
            }
            questionArray.push({
              type: element.type,
              reference: !editFlag
                ? questionId + "-q-" + queNo + "-es"
                : appES && appES.getItem().questions[index]
                ? appES.getItem().questions[index].reference
                : questionId + "-q-" + queNo + "-es",
              data: element,
            });
          }
        } else {
          return false;
        }
      });
    }
    if (setAnswer) {
      const req = {
        questions: questionArray,
      };
      return req;
    } else {
      return false;
    }
  };

  const createItemRequestES = (item) => {
    const questionRefArray: any[] = [];
    if (spanishWidgetDataArray.length == 0) {
      englishWidgetDataArray.forEach((element, index) => {
        const queNo = index + 1;
        questionRefArray.push({
          reference: !editFlag
            ? questionId + "-q-" + queNo + "-es"
            : appES && appES.getItem().questions[index]
            ? appES.getItem().questions[index].reference
            : questionId + "-q-" + queNo + "-es",
        });
      });
    } else {
      spanishWidgetDataArray.forEach((element, index) => {
        const queNo = index + 1;
        questionRefArray.push({
          reference: !editFlag
            ? questionId + "-q-" + queNo + "-es"
            : appES && appES.getItem().questions[index]
            ? appES.getItem().questions[index].reference
            : questionId + "-q-" + queNo + "-es",
        });
      });
    }
    const req = {
      items: [
        {
          reference: item.item.reference,
          metadata: null,
          definition: {
            widgets: questionRefArray,
          },
          status: "published",
          questions: questionRefArray,
          tags: [
            {
              type: "item-type",
              name: "question",
            },
          ],
        },
      ],
    };
    return req;
  };
  const UpdateMetadataForSingleMCQ = (element, language, index) => {
    if (
      (element["multiple_responses"] == null ||
        (element["multiple_responses"] != null &&
          element["multiple_responses"] === false)) &&
      element["validation"]["valid_response"]["value"] != null &&
      element["validation"]["valid_response"]["value"].length == 1
    ) {
      const valid_response =
        element["validation"]["valid_response"]["value"][0];
      const options_value = element["options"]
        .filter((x) => x["value"] != valid_response)
        .map((x) => x["value"]);

      let random_val = "";
      if (language === "en") {
        random_val =
          options_value[Math.floor(Math.random() * options_value.length)];
        autoMaskResponseEn.push(random_val);
        setAutoMaskResponseEn([...autoMaskResponseEn]);
      } else {
        random_val =
          autoMaskResponseEn[index] &&
          autoMaskResponseEn[index] != valid_response
            ? autoMaskResponseEn[index]
            : options_value[Math.floor(Math.random() * options_value.length)];
      }
      if (element["metadata"] != null) {
        element["metadata"]["auto_mask_response"] = random_val;
      } else {
        const metadata: any = {
          auto_mask_response: random_val,
        };
        element["metadata"] = metadata;
      }
    }
    return element;
  };
  const esTranslationToggle = (value: boolean) => {
    setESTranslationDone(value);
  };

  async function getAssociatePassages() {
    setLoading(true);
    if (editFlag) {
      const service = await import("../../../api/passage.service");
      const associatePassageResponse = service.getAssociatePassageByQuestionId(
        questionId,
        localStorage.getItem("userId")
          ? localStorage.getItem("userId")
          : props?.profile?.userId || 1
      );
      const passages = (await associatePassageResponse).data;
      const questionAssPassages = [] as unknown as IAssociatedPassages;
      const questionPassageData = [] as ISelectElement[];
      passages.map((passage, index) => {
        questionAssPassages.push({
          associatedPassageId: passage.passageId,
          associatedPassageReferenceIds: [
            passage.englishPassageReferenceId,
            passage.spanishPassageReferenceId,
          ],
        });
        questionPassageData.push({
          value: passage.passageId,
          label: passage.title,
        });
      });
      SetQuestionAssociatedPassageIds(questionAssPassages);
      SetQuestionAssociatedPassage(questionPassageData);
    }
    setLoading(false);
  }

  async function getAssociateVideos() {
    setLoading(true);
    if (editFlag) {
      const service = await import("../../../api/videos.service");
      const associateVideoResponse = service.getAssociateVideoByQuestionId(
        questionId,
        localStorage.getItem("userId")
          ? localStorage.getItem("userId")
          : props?.profile?.userId || 1
      );
      const videos = (await associateVideoResponse).data;
      const questionAssVideos = [] as unknown as IAssociatedVideos;
      videos.map((video, index) => {
        questionAssVideos.push({
          associatedVideoId: video?.videoId,
          associatedVideoReferenceIds: [
            video?.englishVideoReferenceId,
            video?.spanishVideoReferenceId,
          ],
        });
      });
      SetQuestionAssociatedVideoIds(questionAssVideos);
    }
    setLoading(false);
  }
  async function getAssociatePassagesForCopyQuestion(questionId: number) {
    setLoading(true);

    const service = await import("../../../api/passage.service");
    const associatePassageResponse = service.getAssociatePassageByQuestionId(
      questionId,
      localStorage.getItem("userId")
        ? localStorage.getItem("userId")
        : props?.profile?.userId || 1
    );
    const passages = (await associatePassageResponse).data;
    const questionAssPassages = [] as unknown as IAssociatedPassages;
    const questionPassageData = [] as ISelectElement[];
    passages.map((passage, index) => {
      questionAssPassages.push({
        associatedPassageId: passage.passageId,
        associatedPassageReferenceIds: [
          passage.englishPassageReferenceId,
          passage.spanishPassageReferenceId,
        ],
      });
      questionPassageData.push({
        value: passage.passageId,
        label: passage.title,
      });
    });
    SetQuestionAssociatedPassageIds(questionAssPassages);
    SetQuestionAssociatedPassage(questionPassageData);
    setLoading(false);
  }

  async function getAssociateVideosForCopyQuestion(questionId: number) {
    setLoading(true);
    const service = await import("../../../api/videos.service");
    const associateVideoResponse = service.getAssociateVideoByQuestionId(
      questionId,
      localStorage.getItem("userId")
        ? localStorage.getItem("userId")
        : props?.profile?.userId || 1
    );
    const videos = (await associateVideoResponse).data;
    const questionAssVideos = [] as unknown as IAssociatedVideos;
    videos.map((video, index) => {
      questionAssVideos.push({
        associatedVideoId: video?.videoId,
        associatedVideoReferenceIds: [
          video?.englishVideoReferenceId,
          video?.spanishVideoReferenceId,
        ],
      });
    });
    SetQuestionAssociatedVideoIds(questionAssVideos);

    setLoading(false);
  }

  async function saveTags(tags) {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);

    const tag = {
      questionId: Number(questionId),
      tagId: selectedTagIds,
    };
    setSelectedTagIds(selectedTagIds);
    postQuestionTag(tag);
  }

  async function removeTag(allTags, tag) {
    const selectedTagIds = allTags
      .filter((t) => t.selected === true)
      .map((t) => t.tagId);

    const tagParam = {
      questionId: Number(questionId),
      tagId: tag.tagId,
    };
    setSelectedTagIds(selectedTagIds);
    deleteQuestionTag(tagParam);
  }

  const openModal = (id, questionId, questionData) => {
    setOpen(true);
    setPreviewId(id);
    setQuestionIdPreview(questionId);
    setQuestionToPreview(questionData);
  };

  const popUpClose = (value) => {
    setOpen(value);
    setPreviewId("");
    setQuestionIdPreview(undefined);
    setQuestionToPreview(undefined);
  };

  const IsAnswerSet = (element: any) => {
    let isValid = true;
    if (
      isValid &&
      (element?.type === "imageclozeassociationV2" ||
        element?.type === "classification") &&
      element?.validation?.valid_response.value.length > 0
    ) {
      element?.validation.valid_response?.value.map((innerArr) => {
        if (innerArr.length === 0) {
          isValid = false;
        }
      });
    } else if (
      isValid &&
      (element?.type === "clozeformula" ||
        element.type === "imageclozeformula" ||
        element.type === "chemistry" ||
        element.type === "clozechemistry" ||
        element?.type === "imageclozechemistry") &&
      element?.validation.valid_response.value.length > 0
    ) {
      element.validation.valid_response.value.map((innerArr) => {
        // Check if innerArr is an array
        if (Array.isArray(innerArr)) {
          if (innerArr.length === 0) {
            isValid = false;
          } else {
            innerArr.map((innerObject) => {
              if (innerObject.value.length === 0) {
                isValid = false;
              }
            });
          }
        } else {
          // Handle the case where innerArr is a simple object
          if (innerArr.value.length === 0) {
            isValid = false;
          }
        }
      });
    } else if (
      isValid &&
      (element?.validation?.valid_response?.value.length === 0 ||
        (Array.isArray(element?.validation?.valid_response?.value) &&
          element?.validation?.valid_response?.value.length > 0 &&
          element?.validation?.valid_response?.value.some((x) => x === null)))
    ) {
      isValid = false;
    }
    return isValid;
  };

  return (
    <AllowedTo
      perform={[Permissions.question_create, Permissions.question_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}
      <PreviewModal
        modal={openModal}
        show={open}
        changeValue={popUpClose}
        itemRef={previewId}
        questionIdPreview={questionIdPreview}
        setQuestionIdPreview={setQuestionIdPreview}
        setPreviewId={setPreviewId}
        questionToPreview={questionToPreview}
        setQuestionToPreview={setQuestionToPreview}
      ></PreviewModal>

      <div className="w-full" style={{ padding: "25px", overflowX: "hidden" }}>
        <div>
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-light text-gray-900">
              {editFlag ? "Edit Question " : "Create Question"}
            </h3>
          </div>
          <Breadcrumb items={breadcrumbItems()} />
          <div className="mt-4">
            <AuthorQuestionTabs
              dropV={saveSelectdData1}
              setWidget={setWidget}
              questionId={questionId}
              setQuestionId={setQuestionId}
              setpayloadLabel={setpayloadLabel}
              getQuestionTypePayloadSchema={getQuestionTypePayloadSchema}
              setStateId={setStateId}
              setSubjectId={setSubjectId}
              SetDomainId={SetDomainId}
              SetStandardId={SetStandardId}
              SetDOKId={SetDOKId}
              setIsPublished={setIsPublished}
              setIsAIAssisted={setIsAIAssisted}
              setQuestionTypeId={setQuestionTypeId}
              selectedStateId={selectedStateId}
              selectedSubjectId={selectedSubjectId}
              selectedDomainId={selectedDomainId}
              questionEditData={copyFlag ? copyQuestionData : questionEditData}
              editFlag={editFlag}
              copyFlag={copyFlag}
              isPublished={isPublished}
              isAIAssisted={isAIAssisted}
              isDiagnostics={isDiagnostics}
              setIsDiagnostics={setIsDiagnostics}
              language={language}
              setExternalSourceTypeId={setExternalSourceTypeId}
              setExternalSourceId={setExternalSourceId}
              externalSourceTypeId={externalSourceTypeId}
              externalSourceId={externalSourceId}
              getQuestionTag={getQuestionTag}
              editSelectedTags={selectedTags}
              associatedPassageIds={questionAssociatedPassageIds}
              associatedPassage={questionAssociatedPassage}
              associatedVideoIds={questionAssociatedVideoIds}
              classification={classification}
              setClassification={setClassification}
              handleSaveTags={saveTags}
              handleRemoveTag={removeTag}
              selectedTagIds={selectedTagIds}
              associatedPassageClassification={passageClassification}
              associateStandardId={parameters?.associateStandardId}
              associateStandardName={parameters?.associateStandardName}
              associateStandardData={parameters?.associateStandardData}
              createQuestion={createQuestion}
              unLinkedStandardId={unlinkedStandardId}
              setShowSetAnswerErrorEnglish={setShowSetAnswerErrorEnglish}
              setShowSetAnswerErrorSpanish={setShowSetAnswerErrorSpanish}
              setIsMachineTranslated={setIsMachineTranslated}
              isMachineTranslated={isMachineTranslated}
              esTranslationDone={esTranslationDone}
              contentAreadId={
                questionEditData.contentAreaId
                  ? questionEditData.contentAreaId
                  : 0
              }
              gradeLevel={
                questionEditData.gradeLevel ? questionEditData.gradeLevel : ""
              }
            />
          </div>
          <div className="flex justify-end mt-4 gap-4">
            <button
              type="button"
              className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
              onClick={(e) => saveQuestionData(e, false)}
            >
              {editFlag ? "Update " : "Save"}
            </button>
            {questionId && (
              <button
                type="button"
                className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                onClick={(e) => saveQuestionData(e, true)}
              >
                Save and Copy
              </button>
            )}
            <button
              type="button"
              className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
              onClick={(e) => navigate("/questions")}
            >
              Cancel
            </button>
            {editFlag && (
              <button
                type="button"
                className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                onClick={(e) =>
                  openModal(
                    questionEditData.englishQuestionReferenceId,
                    questionId,
                    questionEditData
                  )
                }
              >
                Preview
              </button>
            )}
          </div>

          {((((questionAssociatedPassageIds &&
            questionAssociatedPassageIds.length > 0) ||
            (questionAssociatedVideoIds &&
              questionAssociatedVideoIds?.length > 0)) &&
            questionId &&
            !editFlag) ||
            classification === 3) && (
            <div className="flex justify-end mt-4 gap-4">
              <button
                type="button"
                className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                onClick={(e) => AddDivElement(e)}
              >
                Add More Questions
              </button>
            </div>
          )}

          <div className="mt-2 question-editor-div">{questionEditor}</div>

          {showImageGalleryPopup && (
            <div
              className="fixed z-10 inset-0 overflow-y-auto"
              aria-labelledby="modal-title"
              role="dialog"
              aria-modal="true"
            >
              <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div
                  className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                  aria-hidden="true"
                ></div>

                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <div className="inline-block w-full align-bottom bg-white px-4 pt-5 pb-8 text-left  shadow-xl transform transition-all sm:align-middle sm:max-w-[80%] sm:w-full sm:p-6">
                  <div className=" flex justify-end">
                    <button
                      onClick={() => setShowImageGalleryPopup(false)}
                      type="button"
                      className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    >
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <ImageGallery></ImageGallery>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showLinkedStandards && linkedStandards && linkedStandards.length > 0 && (
        <DelinkStandardPopup
          standardId={standardToDelink}
          title={"Linked Standards"}
          buttonText={"Ok"}
          linkedStandardsData={linkedStandards}
          onClose={closeLinkedStandardsPopUp}
          disableAction={true}
        />
      )}
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(AuthorQuestion);
